import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { store } from '../../../common/stores/store';
import {
    AuthenticatedUserModel,
    AuthenticationResultModel,
    LoginModel,
    UpdateUserPassword,
} from '../../../models/security';

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

const requestWithTokenInterceptor = (config: AxiosRequestConfig) => {
    const token = store.commonStore.token;

    if (token) config!.headers!.Authorization = `Bearer ${token}`;
    return config;
};

axios.interceptors.request.use(requestWithTokenInterceptor);

const responseBody = (response: AxiosResponse) => response.data;

export const ssoRequests = {
    login: (credentials: LoginModel): Promise<AuthenticationResultModel> => {
        axios.defaults.baseURL = process.env.REACT_APP_API_URL;
        return axios
            .post('/stockholm/api/accounts/login', credentials)
            .then(responseBody);
    },
    current: (): Promise<AuthenticationResultModel> => {
        axios.defaults.baseURL = process.env.REACT_APP_API_URL;
        return axios.get('/stockholm/api/accounts').then(responseBody);
    },

    getMe: (): Promise<any> => {
        axios.defaults.baseURL = process.env.REACT_APP_API_URL;
        return axios.get('/stockholm/api/me').then(responseBody);
    },

    changePassword: (newCredentials: UpdateUserPassword) => {
        axios.defaults.baseURL = process.env.REACT_APP_API_URL;
        return axios
            .put('/stockholm/api/accounts/update-password', newCredentials)
            .then(responseBody);
    },
};
